<template>
  <div>
    <el-input v-model="tmp" placeholder="搜索订单编号" readonly clearable @focus="eventOrderNo"/>
    <el-dialog title="依据订单编号查询" :visible.sync="show" width="30%">
      <el-input
          type="textarea"
          placeholder="查询多个订单编号，以英文逗号、空格或回车键隔开"
          v-model="order_nos"
          maxlength="5000"
          :autosize="{ minRows: 4, maxRows: 25}"
          show-word-limit
      />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" icon="el-icon-search" @click="handleDo">查 单</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "SOrderNos",
  props: {
    value: {
      type: [String],
      required: true,
    }
  },
  data() {
    return {
      order_nos: '',
      show: false,
      tmp: null,
    }
  },
  watch: {
    tmp(_) {
      this.order_nos = _ ? this.order_nos : ''
      this.$emit('update:value', this.order_nos)
    },
    value(_) {
      this.tmp = _ ? this.tmp : ''
    }
  },
  methods: {
    eventOrderNo: function () {
      this.show = true
    },
    handleDo: function () {
      this.show = false
      this.tmp = this.order_nos
    }
  }

}
</script>
<style scoped>

</style>
